"use strict";

import jQuery from 'jquery';

/**
 * Control zur Manipulation des Rotationswinkel der Karte.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCRotate = function( options )
{
	gc.gis.control.GCAbstractMapControl.call( this, options );
};
gc.gis.control.GCRotate.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCRotate.prototype.init = function()
{
	var self = this;

	this._render();

	this._map.on( gc.gis.map.GCMapEvent.ROTATION_CHANGED, this, function(evt ) {
		self.__element_rotation.css('transform', 'rotate('+ evt.rotation +'deg)');
	} );
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCRotate.prototype._render = function()
{
	var self = this;

	if( !this._element )
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-rotate'
		});

		this.__element_rotate_cw = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-rotate-cw',
			title: '10° im Urzeigersinn drehen',
			html: '<span>10° im Urzeigersinn drehen</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
					self._map.setRotation(self._map.getRotation() + 10);
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});
		gc.gis.iface.ui.tooltip(this.__element_rotate_cw);

		this.__element_rotate_ccw = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-rotate-ccw',
			title: '10° gegen den Urzeigersinn drehen',
			html: '<span>10° gegen den Urzeigersinn drehen</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
                    self._map.setRotation( self._map.getRotation()-10 );
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});
		gc.gis.iface.ui.tooltip(this.__element_rotate_ccw);

		this.__element_rotate_reset = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-rotate-reset',
			title: 'Nach Norden ausrichten',
			html: '<span>Nach Norden ausrichten</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
                    self._map.setRotation( 0 );
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});
		gc.gis.iface.ui.tooltip(this.__element_rotate_reset);

		this.__element_rotation = jQuery('<span>', {
			'class': 'gc-map-control-rotation',
			style: 'transform: rotate('+ this._map.getRotation() +'deg)'
		});
		this.__element_rotate_reset.append( this.__element_rotation );

		this._element
			.append( this.__element_rotate_reset )
			.append( this.__element_rotate_cw )
			.append( this.__element_rotate_ccw );
	}
	return this._element;
};

